import React, { Component } from "react";
import { connect } from "react-redux";

import { getEvents } from "../../actions/events";
import { getStoriesStream } from "../../../actions/storiesStream";
import StoryCard from "../../../components/Library/StoryCard";
import StoriesStream from "../../../components/Library/StoriesStream";
import SectionContainer from "../../../components/Library/SectionContainer";
import Spinner from "../../../components/Library/Spinner";

class PassedEvents extends Component {

  componentDidMount() {
    if (!this.props.story) {
      this.props.getStoriesStream({ stream: "events" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.story && !nextProps.story) {
      this.props.getStoriesStream({ stream: "events" });
    }
  }

  loadNextStories = (page) => {
    return this.props.getStoriesStream({ stream: "events", page }, true);
  };

  render() {
    const { story, storiesStream } = this.props;
    if (story) return <StoryCard story={story}/>;

    if (storiesStream.isLoading && storiesStream.results.length === 0) return <Spinner/>;
    if (storiesStream.isFinished && storiesStream.results.length === 0) return null;

    return (
      <SectionContainer header="Past Events">
        <StoriesStream
          stories={this.props.storiesStream}
          isEvent={true}
          showUnread={false}
          next={this.loadNextStories}
        />
      </SectionContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    storiesStream: state.storiesStream,
    events: state.upcomingEvents,
  };
};

const mapDispatchToProps = {
  getEvents,
  getStoriesStream,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PassedEvents);



// WEBPACK FOOTER //
// ./src/events/components/PassedEvents/PassedEvents.js